export default "__VITE_ASSET__de6d185c__"